import { MoveStationSaveStatus } from "./hub-messages/receive-move-station-command-message";

interface Station {
  stationId: string;

  coordinateX: number;
  coordinateY: number;
  coordinateTheta: number;
  hasChargingCapability: boolean;
}

export default Station;

export interface StationDrag {
  isDragging: boolean;
  isSelected: boolean;
  error: string | null;
  saveStatus: MoveStationSaveStatus;
  unsavedChanges: boolean;
}

export interface StationDragPatch extends StationDrag {
  position: {
    coordinateX: number;
    coordinateY: number;
    coordinateTheta: number;
  };
}

export interface FloorStation {
  id: string;
  coordinateX: number;
  coordinateY: number;
  coordinateTheta: number;
  isTransition: boolean;
}

export const getDefaultChargingStationMove = (station: Station) =>
  ({
    position: {
      coordinateX: station.coordinateX,
      coordinateY: station.coordinateY,
      coordinateTheta: station.coordinateTheta,
    },
    isDragging: false,
    isSelected: false,
    error: null,
    saveStatus: MoveStationSaveStatus.Idle,
    unsavedChanges: false,
  }) as StationDrag;
